import PropTypes from 'prop-types';
import Layout from 'layouts/Default';
import { Section } from 'elements/Containers';
import PostCard from 'components/PostCard';
import Pagination from 'components/Pagination';
import BlogCta from 'components/BlogCta';
import Yoast from 'components/Yoast';

import { getPaginatedPosts, getPostCount, getSEOForHome } from 'lib/api';
import Canonical from 'components/Canonical';

const PaginatedPage = ({
  posts: { edges },
  seo,
  data: { pages },
  currentPage,
}) => (
  <Layout>
    <Canonical />
    <Yoast seo={seo} />
    <Section>
      <div className="mx-auto mt-12 grid max-w-lg gap-5 lg:max-w-none lg:grid-cols-3">
        {edges.map(({ node }, index) => (
          <PostCard
            key={node.id}
            id={node.id}
            slug={node.slug}
            featuredImage={node.featuredImage}
            categories={node.categories}
            title={node.title}
            author={node.author}
            date={node.date}
            priority={index <= 2}
          />
        ))}
      </div>
      <Pagination
        title={seo.title}
        currentPage={currentPage}
        totalPages={pages}
      />
      <BlogCta />
    </Section>
  </Layout>
);

PaginatedPage.propTypes = {
  posts: PropTypes.shape([]).isRequired,
  seo: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
  data: PropTypes.shape({
    pages: PropTypes.number.isRequired,
  }).isRequired,
  currentPage: PropTypes.number.isRequired,
};

export const getStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps = async ({ params }) => {
  const { posts } = await getPaginatedPosts(params.page);
  const {
    page: { seo },
  } = await getSEOForHome();
  const data = await getPostCount();

  if (posts.edges.length === 0) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      posts,
      seo,
      currentPage: parseInt(params.page, 10),
      data,
    },
    revalidate: 900,
  };
};

export default PaginatedPage;
